import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbsLabel from './BreadcrumbsLabel';

/**
 * A single breadcrumb label wrapped up as a link.
 */
const BreadcrumbsLink = ({ children, href, current }) => {
  const aria = current ? { 'aria-current': 'page' } : {};
  return (
    <a className="c-breadcrumbs__link" href={href} {...aria}>
      <BreadcrumbsLabel>{children}</BreadcrumbsLabel>
    </a>
  );
};

export default BreadcrumbsLink;

BreadcrumbsLink.propTypes = {
  children: PropTypes.node.isRequired,
  current: PropTypes.bool,
};

BreadcrumbsLink.defaultProps = {
  current: false,
};
